
  import { Component, OnInit } from '@angular/core';
  import { ActivatedRoute } from '@angular/router';
  import { ApiService } from 'app/shared/services/api.service';
  import { environment } from 'environments/environment';
  
  @Component({
    selector: 'app-view',
    templateUrl: './view.component.html',
    styleUrls: ['./view.component.scss','../../../../../../assets/sass/pages/page-users.scss']
  })
  export class ViewComponent implements OnInit {
    employeeId:any;
    employeeData:any
    imageUrl=environment.apiUrls.imageUrl;
  
  
  
    constructor(private apiService:ApiService,private activatedroute:ActivatedRoute) { 
      this.activatedroute.paramMap.subscribe(params => { 
        this.employeeId = params.get('id'); 
        console.log('employeeId',this.employeeId)
       
    });
  
    }
  
    ngOnInit(): void {
      this.getEmployeeById()
    }
    // getBusinessById(){
    //   this.apiService.getBusinessById(this.businessId).subscribe((res:any)=>{
    //     if(res.statusCode === 200){
    //       console.log(res)
    //       this.businessData =res.data 
    //     }
  
    //   })
    // }
    getEmployeeById(){
      this.apiService.getEmployeeById(this.employeeId).subscribe((res:any)=>{
        this.employeeData=res.data
        console.log('employee data',this.employeeData)

      })
    }
  }
  
